export default __webpack_public_path__ + "static/media/contact.27187ba0.jpg";